module.exports = __webpack_public_path__ + "img/Slide41.ddd71c14.png";